import { createBaseApi } from './apis/baseApi';

// Create the main API slice instance
// The reducerPath is the name of the slice in the Redux store
export const apiSlice = createBaseApi('api');

// You can export additional utilities or selectors from here if needed
// For example, if you want to easily access the reducer or middleware:
// export const { reducer, middleware } = apiSlice; 